define.alias("shared/components/shared/typeform-survey-trigger", "settings/components/shared/typeform-survey-trigger");